import { render, staticRenderFns } from "./ECometencys.vue?vue&type=template&id=3bd71bed"
import script from "./ECometencys.vue?vue&type=script&lang=js"
export * from "./ECometencys.vue?vue&type=script&lang=js"
import style0 from "./ECometencys.vue?vue&type=style&index=0&id=3bd71bed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports